import { http as axios } from "@/general/utils/http";
import {
  GiveThanksPoints,
  ListResponse,
  ThankPointMessage,
  ThankPointSearchByUser,
  ThanksPoint,
  ThanksPointMessageHasRead,
  ThanksPointSearch,
  ThanksPointUser,
  ThanksPointUserSelect
} from "../store/models";

/**
 * Thanks point api
 */
export default class ThanksPointApi {
  /**
   * Get thanks point list
   * @param page
   * @param pageSize
   * @param search
   *
   * @return Promise|Error
   */
  public static async getThankPointList(
    page?: number | undefined,
    pageSize?: number | undefined,
    search?: string,
    user?: number
  ) {
    const response: ListResponse<ThanksPoint> = await axios.get(
      `api/thanks-point`,
      {
        params: {
          page,
          page_size: pageSize,
          search,
          user
        }
      }
    );
    return response;
  }

  /**
   * Search thanks point by user
   *
   * @param page
   * @param pageSize
   * @param search
   * @returns Promise|Error
   */
  public static async searchThanksPointByUser(
    page: number | undefined,
    pageSize: number | undefined,
    search: string | undefined
  ) {
    const response: ListResponse<ThankPointSearchByUser> = await axios.get(
      `api/search_thanks_giving_by_user`,
      {
        params: {
          page,
          page_size: pageSize,
          search
        }
      }
    );
    return response;
  }

  /**
   * get thanks point message list
   *
   * @param page
   * @param pageSize
   * @param thanks_giving_id
   * @returns Promise|Error
   */
  public static async getThanksPointMessageList(
    page: number,
    page_size: number | undefined,
    thanks_giving_id: number
  ) {
    const response: ListResponse<ThankPointMessage> = await axios.get(
      `api/thanks_giving_message/${thanks_giving_id}`,
      {
        params: {
          page,
          page_size
        }
      }
    );
    return response;
  }

  /**
   *  post thanks point message
   *
   * @param to_user_id
   * @param message
   * @param parent
   * @returns Promise|Error
   */
  public static async postThanksPointMessage(
    to_user_id: number,
    message: string | undefined,
    parent: number,
    thanks_giving_id: number
  ) {
    const response: ThankPointMessage = await axios.post(
      `api/thanks_giving_message`,
      {
        to_user_id,
        message,
        parent,
        thanks_giving_id
      }
    );
    return response;
  }

  /**
   *  patch thanks point message
   *
   * @param thanks_giving_id
   * @param ordering
   * @param search
   * @param has_read
   * @returns Promise|Error
   */
  public static async patchThanksPointMessage(
    thanks_giving_id: number,
    ordering: string | undefined,
    search: string | undefined,
    has_read: boolean
  ) {
    const response: ThanksPointMessageHasRead = await axios.patch(
      `api/thanks_giving_message`,
      {
        thanks_giving_id,
        ordering,
        search,
        has_read
      }
    );
    return response;
  }

  /**
   * get thanks point user selection
   *
   * @param page
   * @param page_size
   * @param search
   * @returns Promise|Error
   */
  public static async getThanksPointUserSelection(
    page: number,
    page_size: number | undefined,
    search: string | undefined,
    ordering: string | undefined
  ) {
    const response: ListResponse<ThanksPointUserSelect> = await axios.get(
      `api/customUser`,
      {
        params: {
          page,
          page_size,
          search,
          ordering
        }
      }
    );
    return response;
  }

  /**
   * get give thanks point
   *
   * @param search
   * @param user_name
   * @returns Promise|Error
   */
  public static async getGiveThanksPoints(
    id: number,
    search: string | undefined,
    user_name: string | undefined
  ) {
    const response: GiveThanksPoints = await axios.get(
      `api/thanks_point_giving_type/${id}`,
      {
        params: {
          search,
          user_name
        }
      }
    );
    return response;
  }

  /**
   *  post thanks point
   *
   * @param points_to_send
   * @param title
   * @param message
   * @param to_user
   * @returns Promise|Error
   */
  public static async postThanksPoint(
    points_to_send: number,
    title: string | undefined,
    message: string | undefined,
    to_user: number,
  ): Promise<any> {
    return await axios.post(`api/thanks-point`, {
      points_to_send,
      title,
      message,
      to_user
    });
  }
}
